import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DebounceModule } from '../../directives/debounce/debounce.module';
import { ConfirmationDialogComponent } from './confirmation-dialog.component';
import { ConfirmationDialogService } from './_provider/confirmation-dialog.service';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        MatDialogModule,
        MatButtonModule,
        DebounceModule,
        MatProgressSpinnerModule
    ],
    declarations: [
        ConfirmationDialogComponent
    ],
    providers: [
        ConfirmationDialogService
    ],
    exports: [
        ConfirmationDialogComponent
    ]
})
export class ConfirmationDialogModule { }
